import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4f653161"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4f653161&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TlmButton: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/TlmButton.vue').default,CardTop: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/CardTop.vue').default,TlmDivider: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/TlmDivider.vue').default,TlmCounter: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/TlmCounter.vue').default,FamilyShoppingList: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/family/ShoppingList.vue').default,FamilyMaxSubscriptionsReached: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/family/MaxSubscriptionsReached.vue').default,TlmContainer: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/TlmContainer.vue').default})
